var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"trav-rating",class:`ratingBgColor${_vm.colorNumber}`},[_c('i',{staticClass:"icon-i16_like"}),_vm._v("\n    "+_vm._s(_vm.rating)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }